import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const LandingRoute = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // If authenticated, redirect to appropriate dashboard
  if (isAuthenticated && user) {
    if (user.role === 'player') {
      return <Navigate to="/player/dashboard" replace />;
    } else if (user.role === 'coach') {
      return <Navigate to="/coach/dashboard" replace />;
    } else if (user.role === 'scout') {
      return <Navigate to="/scout/dashboard" replace />;
    } else if (user.role === 'admin' || user.role === 'superAdmin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  // User is not authenticated, show landing page
  return children;
};

export default LandingRoute;
